import { ReactElement } from 'react';
import { Link } from '@mui/material';
import { getSchema } from '@localstack/services';
import { EC2SecurityGroup } from '@localstack/types';

import { MagicTable } from '../../magic/MagicTable';

export type SecurityGroupsTableProps = {
  selectable?: boolean;
  loading?: boolean;
  securityGroups: EC2SecurityGroup[];
  onViewSecurityGroup?: (securityGroup: EC2SecurityGroup) => unknown;
  onSelect?: (ids: string[]) => void;
};

export const SecurityGroupsTable = ({
  securityGroups,
  selectable = true,
  loading,
  onViewSecurityGroup,
  onSelect,
}: SecurityGroupsTableProps): ReactElement => (
  <MagicTable
    schema={getSchema('EC2')}
    entry="SecurityGroup"
    idAttribute="GroupId"
    rows={securityGroups}
    selectable={selectable}
    onSelect={onSelect}
    order={['GroupId', 'GroupName', 'Description', 'VpcId', 'OwnerId']}
    filterColumns={['GroupId', 'GroupName', 'Description', 'VpcId', 'OwnerId']}
    hideEmptyColumns
    loading={loading}
    externalFields={{
      GroupId: (row) => (
        <Link onClick={() => onViewSecurityGroup && onViewSecurityGroup(row)} underline="hover">
          {row.GroupId}
        </Link>
      ),
    }}
  />
);
